export const ACTIONS = {
  SHOW_OR_HIDE_BOARD: 'SHOW_OR_HIDE_BOARD',
};

export function showHideBoard(state) {
  return dispatch =>
    dispatch({
      type: ACTIONS.SHOW_OR_HIDE_BOARD,
      payload: state,
    });
}
